import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button } from 'reactstrap'
import { message } from 'antd'

import { storeBannedDay } from '../services'
import { handleError } from '../../../helpers'

export default function NewBannedDay({ reload }) {
	const { handleSubmit, errors, register, reset } = useForm()

	const onSubmit = values => {
		console.log(values)
		storeBannedDay(values)
			.then(() => {
				message.success('Fecha agregada exitosamente')
				reset()
				reload()
			})
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<Form onSubmit={handleSubmit(onSubmit)}>
				<Form.Group>
					<Form.Label>Fecha <span className="text-primary">*</span></Form.Label>
					<Form.Control 
						type="date"
						name="date"
						ref={register({ required: true })}
					/>
					{ errors.date && <Form.Text className="text-warning">Este campo es requerido</Form.Text> }
				</Form.Group>
				<Form.Group>
					<Form.Label>Descripción <span className="text-primary">*</span></Form.Label>
					<Form.Control 
						name="description"
						ref={register({ required: true })}
					/>
					{ errors.description && <Form.Text className="text-warning">Este campo es requerido</Form.Text> }
				</Form.Group>
				<Button type="submit" color="primary">Agregar Fecha No Hábil</Button>
			</Form>
		</React.Fragment>
	)
}